__turbopack_context__.v({
  "counter": "Counter-module-scss-module__OJCpva__counter",
});
